import React, { ReactElement } from "react";

import {
    DocumentFile as DocumentFileType,
    DocumentLink as DocumentLinkType,
    SingleDocument,
} from "interfaces/content";
import DocumentFile from "../DocumentFile/DocumentFile";
import DocumentLink from "components/content/DocumentLink/DocumentLink";
import { LocalizedString } from "interfaces/common";
import styled from "styled-components";
import styles from "styles/styles";

const Container = styled.div`
    margin: 0em;
    widht: 100%;
    background-color: ${styles.colors.white};
`;

export interface Props {
    document: SingleDocument;
}

export const extractDocumentTags = (document: SingleDocument, locale: string): string[] => {
    const tags = (document.documentTags ?? [])
        .map((tag) => tag.label[locale as keyof LocalizedString])
        .filter((tag): tag is string => !!tag);

    return tags;
};

export const isDocumentFile = (document: SingleDocument): document is DocumentFileType =>
    document.type === "document";

export const isDocumentLink = (document: SingleDocument): document is DocumentLinkType =>
    document.type === "documentLink";

function Document({ document }: Props): ReactElement {
    return (
        <Container>
            {isDocumentFile(document) && <DocumentFile document={document} />}
            {isDocumentLink(document) && <DocumentLink document={document} />}
        </Container>
    );
}

export default Document;
